import axios from 'axios';

const submitContactForm = async (contact) => {
    const prodBaseUrl = process.env.NODE_ENV === 'production'
        ? 'https://api.mrreedsteamlab.com'
        : '';
    const endpoint = `${prodBaseUrl}/api/contact`;

    try {
        return await axios.post(endpoint, contact, {
            headers: { 'Content-Type': 'application/json' },
        });
    } catch (error) {
        const message = error.response?.data?.message
            || 'We could not send your inquiry. Please try again later.';
        throw new Error(message);
    }
};

export default submitContactForm;
